const PEOPLE_1_TO_5 = '1-5'
const PEOPLE_6_TO_29 = '6-29'
const PEOPLE_30_TO_99 = '30-99'
const PEOPLE_100_TO_199 = '100-199'
const PEOPLE_200_PLUS = '200+'

const companyEmployees = [
  { value: PEOPLE_1_TO_5, label: '1 a 5 pessoas' },
  { value: PEOPLE_6_TO_29, label: '6 a 29 pessoas' },
  { value: PEOPLE_30_TO_99, label: '30 a 99 pessoas' },
  { value: PEOPLE_100_TO_199, label: '100 a 199 pessoas' },
  { value: PEOPLE_200_PLUS, label: 'Mais de 199 pessoas' }
]

const meCompanySize = [PEOPLE_1_TO_5]
const pCompanySize = [PEOPLE_6_TO_29]
const mlaCompanySize = [PEOPLE_30_TO_99, PEOPLE_100_TO_199, PEOPLE_200_PLUS]

export {
  companyEmployees,
  PEOPLE_1_TO_5,
  PEOPLE_6_TO_29,
  PEOPLE_30_TO_99,
  PEOPLE_100_TO_199,
  PEOPLE_200_PLUS,
  meCompanySize,
  pCompanySize,
  mlaCompanySize
}
